// Copyright 2016 Sorama B.V.

import { IFrequencyDomainBeamformer } from "algorithms/IFrequencyDomainBeamformer";
import { Complex } from "libraries/DataTypes/Complex";
import { Point3 } from "libraries/DataTypes/Point3";

export class FrequencyDomainBeamformerJS implements IFrequencyDomainBeamformer {
    Beamform(
        holograms: Complex[][],
        frequencies: number[],
        sensorPositions: Point3[],
        targetPoints: Point3[],
        signalSpeed: number
    ): number[] {
        // Check size of hologram
        if (holograms.length !== frequencies.length)
            throw new Error("Number of holograms does not match the number of frequencies");

        // Precompute conversion factor for reduced number of multiplications
        const inverseSpeed2Pi = (1.0 / signalSpeed) * Math.PI * 2;
        const result = <number[]>new Array(targetPoints.length);
        for (let iTp = 0; iTp < targetPoints.length; iTp++) {
            result[iTp] = 0.0;
            const tp = targetPoints[iTp];

            for (let iF = 0; iF < frequencies.length; iF++) {
                let resultFreq = new Complex(0.0, 0.0);
                for (let iMp = 0; iMp < sensorPositions.length; iMp++) {
                    // Compute distance between microphone position and targetpoint
                    const tau = Point3.Distance(sensorPositions[iMp], tp) * inverseSpeed2Pi;

                    const f = frequencies[iF];
                    const steerFactor = Complex.Exp(1.0, tau * f);

                    resultFreq = Complex.Add(resultFreq, Complex.Multiply(steerFactor, holograms[iF][iMp]));
                }

                result[iTp] += resultFreq.Magnitude();
            }
        }

        return result;
    }
}
